
import { defineComponent, ref } from "vue";
import Main from "./views/Main.vue";
import Start from "./views/Start.vue";

export default defineComponent({
  name: "App",
  components: {
    "app-main": Main,
    "app-dialog": () => import("./components/Dialog.vue"),
    "app-start": Start
  },
  setup() {
    // Работа с диалоговым окном
    const active = ref(false);

    return {
      active
    };
  }
});
